// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var Chart = function Chart(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M7.325 7.359v-6.01a7.011 7.011 0 00-6.01 6.01zm7.36 1.485a5.708 5.708 0 01-5.739 5.807A5.852 5.852 0 013.07 8.709h5.6V3.037a5.853 5.853 0 016.015 5.807z"
    }))
  );
};

export default Chart;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/Chart.js
// module id = 991
// module chunks = 0